__turbopack_context__.v({
  "arrow": "public-profile-module___ljYUG__arrow",
  "avatar": "public-profile-module___ljYUG__avatar",
  "bio": "public-profile-module___ljYUG__bio",
  "card": "public-profile-module___ljYUG__card",
  "event": "public-profile-module___ljYUG__event",
  "hero": "public-profile-module___ljYUG__hero",
  "page": "public-profile-module___ljYUG__page",
});
